import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SundayClosuresCard = ({ getAuthHeader }) => {
  const [closures, setClosures] = useState([]);
  const [date, setDate] = useState('');
  const [note, setNote] = useState('');
  const [err, setErr] = useState('');

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/admin/sunday-closures`, { headers: getAuthHeader() });
      setClosures(res.data || []);
    } catch { /* ignore */ }
  }, [getAuthHeader]);

  useEffect(() => { load(); }, [load]);

  const addClosure = async () => {
    setErr('');
    try {
      await axios.post(`${API}/admin/sunday-closures`, { date, note }, { headers: getAuthHeader() });
      setDate(''); setNote('');
      load();
    } catch (e) {
      setErr(e.response?.data?.detail || 'Could not save');
    }
  };

  const removeClosure = async (d) => {
    try {
      await axios.delete(`${API}/admin/sunday-closures/${d}`, { headers: getAuthHeader() });
      load();
    } catch { /* ignore */ }
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6" data-testid="sunday-closures-card">
      <h3 className="text-lg font-bold text-gray-800">Sunday Closures</h3>
      <p className="text-sm text-gray-600 mb-4">The website banner announces every Sunday as open (with that day&apos;s events). Mark a Sunday closed here and the banner will say so instead.</p>
      <div className="flex flex-wrap gap-2 items-end mb-3">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Sunday date</label>
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="p-2 border rounded-lg" data-testid="closure-date-input" />
        </div>
        <div className="flex-1 min-w-[180px]">
          <label className="block text-xs font-medium text-gray-600 mb-1">Reason shown on banner (optional)</label>
          <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="e.g., festival weekend" className="w-full p-2 border rounded-lg" data-testid="closure-note-input" />
        </div>
        <button onClick={addClosure} disabled={!date} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50" data-testid="closure-add-btn">Mark closed</button>
      </div>
      {err && <p className="text-sm text-red-600 mb-2" data-testid="closure-error">{err}</p>}
      {closures.length === 0 ? (
        <p className="text-sm text-gray-500 italic">No upcoming closures — all Sundays open.</p>
      ) : (
        <ul className="space-y-2">
          {closures.map((c) => (
            <li key={c.date} className="flex items-center justify-between bg-red-50 border border-red-200 rounded-lg px-3 py-2 text-sm" data-testid={`closure-row-${c.date}`}>
              <span>🚫 <strong>{c.date}</strong>{c.note ? ` — ${c.note}` : ''}</span>
              <button onClick={() => removeClosure(c.date)} className="text-red-600 hover:underline" data-testid={`closure-remove-${c.date}`}>Reopen</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
